module.exports = __webpack_public_path__ + "assets/logo3.78f55af1.svg";